// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.W3T80_1QDDXDyuuY0xsB {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--grey-color-70);
  transition: color 0.2s;
  padding: 4px;
  height: 32px;
  width: 32px;
  box-sizing: border-box;
}

.W3T80_1QDDXDyuuY0xsB:hover {
  background: var(--grey-color-10);
  color: var(--grey-color-70);
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/DeleteReportIcon/DeleteReportIcon.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,2BAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;AACF;;AAEA;EACE,gCAAA;EACA,2BAAA;EACA,kBAAA;AACF","sourcesContent":[".deleteIconContainer {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--grey-color-70);\n  transition: color 0.2s;\n  padding: 4px;\n  height: 32px;\n  width: 32px;\n  box-sizing: border-box;\n}\n\n.deleteIconContainer:hover {\n  background: var(--grey-color-10);\n  color: var(--grey-color-70);\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deleteIconContainer": `W3T80_1QDDXDyuuY0xsB`
};
export default ___CSS_LOADER_EXPORT___;
